<div class="container-xl">
  <div class="row justify-content-center">
    <div class="col-12 align-self-center text-center">
      <mat-spinner color="accent" class="mx-auto d-block" [diameter]="30"></mat-spinner>
    </div>
  </div>
</div>
